import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Row } from 'reactstrap';

function CubDataFieldArray({
  cubInventory = [],
  cubFunction = [],
  currentJob,
  cubDetails = [],
  onSave,
  currentState,
}) {

  const [selectedCubs, setSelectedCubs] = useState([]);

  const [selectedFunction, setSelectedFunction] = useState('');
  const [selectedFunctions, setSelectedFunctions] = useState([]);

  /*
   * Send the current CUB list to the parent whenever it changes
   */
  useEffect(() => {
    if (onSave) {
      onSave(selectedCubs);
    }
  }, [selectedCubs, onSave]);

  /*
   * Load existing CUB details
   */
  useEffect(() => {
    if (!Array.isArray(cubDetails)) {
      return;
    }


    

    setSelectedCubs(
      cubDetails.map(cub => ({
        shortname: cub.cubname || cub.shortname,
        serialnumber: cub.cubserialnumber || cub.serialnumber,
        role: cub.role,
      }))
    );
  }, [cubDetails]);

  /*
   * CUB selected in the main CUB dropdown
   */
  const [selectedCub, setSelectedCub] = useState('');

  /*
   * Currently selected yard for each CUB
   */
  const [selectedYards, setSelectedYards] = useState({});

  /*
   * Add selected CUB
   */
  const addCub = () => {

    if (!selectedCub || !selectedFunction) {
      return;
    }

   
    const cub = cubInventory.find(
      item =>
        String(item.cubserialnumber) ===
        String(selectedCub)
    );

    /*
     * Find selected role
     */
    const func = cubFunction.find(
      item =>
        String(item.role) ===
        String(selectedFunction)
    );

    if (!cub || !func) {
      return;
    }

    /*
     * Don't allow the same CUB twice
     */
    const alreadyExists = selectedCubs.some(
      item =>
        String(item.serialnumber) ===
        String(cub.cubserialnumber)
    );

    if (alreadyExists) {
      return;
    }

    /*
     * Convert the inventory structure into
     * the structure used by selectedCubs
     */
    setSelectedCubs(prev => [
      ...prev,
      {
        shortname:cub.shortname|| cub.cubshortname,
        serialnumber: cub.cubserialnumber,
        role: func.role,
      }
    ]);

    /*
     * Clear selectors
     */
    setSelectedCub('');
    setSelectedFunction('');
  };

  /*
   * Select yard
   */
  const handleYardChange = (
    cubSerialNumber,
    recordNumber
  ) => {

    setSelectedYards(prev => ({
      ...prev,
      [cubSerialNumber]: recordNumber
    }));

  };

  /*
   * Select function
   */
  const handleFunctionChange = (selectedOption) => {

    setSelectedFunction(
      selectedOption ? selectedOption.value : ''
    );

  };

  /*
   * Add selected yard to CUB
   */
  const addYard = (cubSerialNumber) => {

    const recordNumber =
      selectedYards[cubSerialNumber];

    if (!recordNumber) {
      return;
    }

   

    setSelectedCubs(prevCubs =>
      prevCubs.map(cub => {

        if (
          String(cub.serialnumber) !==
          String(cubSerialNumber)
        ) {
          return cub;
        }

        /*
         * Don't allow duplicate yard
         */
     

   

      })
    );
  };
 const isEditable=()=>{
  console.log('currentState',currentState)
        let isEditable = true;
        if(currentState == 'verified'){
          isEditable = false;
        }
        return isEditable

    }

  /*
   * Remove yard
   */
  const removeYard = (
    cubSerialNumber,
    yardIndex
  ) => {

    setSelectedCubs(prevCubs =>
      prevCubs.map(cub => {

        if (
          String(cub.serialnumber) !==
          String(cubSerialNumber)
        ) {
          return cub;
        }

        return {
          ...cub,

          objrecords:
            (cub.objrecords || []).filter(
              (_, index) =>
                index !== yardIndex
            )
        };

      })
    );

  };

  /*
   * Remove CUB
   */
  const removeCub = (cubSerialNumber) => {
    
    const index = selectedCubs.findIndex(
      cub =>
        String(cub.serialnumber) ===
        String(cubSerialNumber)
    );

    if (index === -1) {
      return;
    }
currentState!='verified' &&currentState!='certified' &&currentState!='failed' && currentState!='cancelled'? 
    setSelectedCubs(prevCubs =>
      prevCubs.filter(
        cub =>
          String(cub.serialnumber) !==
          String(cubSerialNumber)
      )
    ):null;

    setSelectedFunctions(prevFunctions =>
      prevFunctions.filter(
        (_, functionIndex) =>
          functionIndex !== index
      )
    );

  };

  /*
   * CUB dropdown change
   */
  const handleCubChange = (selectedOption) => {

    setSelectedCub(
      selectedOption
        ? selectedOption.value
        : ''
    );

  };

  /*
   * SAVE
   */
  const handleSave = () => {

    console.log(
      'Saving CUB data:',
      selectedCubs
    );

    if (onSave) {
      onSave(selectedCubs);
    }

  };

  /*
   * CUB dropdown options
   *
   * NEW inventory structure:
   *
   * {
   *   cubserialnumber: '12345',
   *   cubshortname: 'cub1'
   * }
   */
  const availableCubs = cubInventory
    .filter(
      cub =>
        !selectedCubs.some(
          selected =>
            String(selected.serialnumber) ===
            String(cub.cubserialnumber)
        )
    )
    .map(cub => ({
      value: cub.cubserialnumber,
      label: `${cub.cubshortname} (${cub.cubserialnumber})`
    }));

  /*
   * Role options
   */
  const functionOptions = cubFunction
    .filter(item => item.role)
    .map(item => ({
      value: item.role,
      label: item.role
    }));

  return (
    <div>

      {/* ADD CUB SECTION */}
       {currentState!='verified'&&currentState!='certified' &&currentState!='failed' && currentState!='cancelled'? 
      <div
     
        style={{
          display: 'block',
          clear: 'both',
          width: '600px',
          margin: '0 0 20px 0',
          boxSizing: 'border-box',
          padding: '15px',
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}
      >

        <div
          style={{
            display: 'flex',
            gap: '8px'
          }}
        >

          <div
            style={{
              fontWeight: 'bold'
            }}
          >
            Add CUB
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}
          >

            {/* CUB SELECT */}
            <div
              style={{
                width: '250px'
              }}
            >

              <Select
                value={
                  availableCubs.find(
                    option =>
                      String(option.value) ===
                      String(selectedCub)
                  ) || null
                }

                onChange={handleCubChange}

                options={availableCubs}

                placeholder="Select Cub.."

                isClearable
                isSearchable

                noOptionsMessage={() =>
                  'No Cubs Selected'
                }
              />

            </div>

            {/* ROLE SELECT */}
            <div
              style={{
                width: '200px'
              }}
            >

              <Select
                value={
                  functionOptions.find(
                    option =>
                      String(option.value) ===
                      String(selectedFunction)
                  ) || null
                }

                onChange={handleFunctionChange}

                options={functionOptions}

                placeholder="Select Role"

                isClearable
                isSearchable

                noOptionsMessage={() =>
                  'No Roles found'
                }
              />

            </div>

            {/* ADD BUTTON */}
            <button
              type="button"
              onClick={addCub}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                marginLeft: '8px',
                padding: '0',
                border: '1px solid #000',
                background: '#fff',
                color: '#000',
                fontSize: '20px',
                fontWeight: 'bold',
                cursor: 'pointer',
                flexShrink: 0
              }}
            >
              +
            </button>
          </div>
        </div>
      </div>
  :null}
      {/* SELECTED CUBS */}
      <div
        style={{
          clear: 'both',
          width: '100%'
        }}
      >

        {selectedCubs.length > 0 && (
          <div
            style={{
              fontWeight: 'bold',
              marginBottom: '10px'
            }}
          >
            Selected CUBs
          </div>
        )}

        <div className="align-items-center">

          <Row className="align-items-center">

            {selectedCubs.map((cub, index) => (

              <div
                key={cub.serialnumber}
                style={{
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxSizing: 'border-box',
                  width: 'auto',
                  marginRight: '10px',
                  marginBottom: '10px'
                }}
              >

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '8px'
                  }}
                >

                  <span>
                    {cub.shortname}
                  </span>

                  <span
                    style={{
                      marginLeft: '8px'
                    }}
                  >
                    ({cub.serialnumber})
                  </span>

                  <span
                    style={{
                      marginLeft: '15px'
                    }}
                  >
                    {cub.role}
                  </span>

                  {/* REMOVE CUB */}
                  <span
                    title="Remove CUB"
                    onClick={() =>
                      removeCub(
                        cub.serialnumber
                      )
                    }
                    style={{
                      cursor: 'pointer',
                      marginLeft: '10px',
                      fontSize: '20px',
                      fontWeight: 'bold'
                    }}
                  >
                    ×
                  </span>

                </div>

              </div>

            ))}

          </Row>

        </div>

      </div>

    </div>
  );
}

CubDataFieldArray.propTypes = {
  cubFunction:
    PropTypes.array,

  cubInventory:
    PropTypes.array,


  onSave:
    PropTypes.func
};

export default CubDataFieldArray;